export const TITLE = 'Gente que lê gera gente que lê! 📚✨'

export const DESCRIPTION = `
Ao indicar um amigo para assinar a TAG, além dele ganhar descontos exclusivos no primeiro kit, você recebe brindes especiais:
<p style="margin-bottom:0px;">▶️ Se a pessoa que você indicar assinar o plano <strong>mensal</strong>, você ganha uma <strong>Case para livros em neoprene + um cupom de R$20,00 para usar na Livraria da TAG</strong>;</p>
<p style="margin-bottom:0px;">▶️ Se a pessoa que você indicar assinar o plano <strong>anual</strong>, você ganha uma <strong>Totebag exclusiva + um cupom de R$80,00 para usar na Livraria da TAG</strong>.</p>
<p style="margin-bottom:0px;">Compartilhe o seu código de indicação de amigos e tenha novos companheiros de leitura. Afinal, leitura boa é leitura compartilhada! 📚</p>
`

export const INFO_DESCRIPTION = 'Confira todas as informações '

export const INFO_DESCRIPTION_LINK = 'https://clube.taglivros.com/clube-indique-um-amigo/'

export const POR_ONDE_INDICAR = 'Por onde você quer indicar?'

export const OPCOES = {
  'EMAIL': 'E-mail',
  'FACEBOOK': 'Facebook',
  'WHATSAPP': 'WhatsApp'
}

export const BOTAO_ENVIAR_EMAIL = 'Enviar email'

export const DIGITE_EMAIL = 'Qual o e-mail da pessoa que você quer indicar?'

export const URL_LP_LEIA_MAIS_CLUBE = `https://leia.taglivros.com/assine/`

export const LINKS_WHATS = {
  'DESKTOP': 'https://web.whatsapp.com/send?text=',
  'MOBILE': 'whatsapp://send?text='
}

export const LINK_FACEBOOK = 'https://www.facebook.com/sharer/sharer.php?u='

